import React, { useEffect, useState } from 'react';
import { useAsyncDebounce } from 'react-table';
import { DebounceMsConfig } from '../../../config';
import { Form } from 'react-bootstrap';
import clsx from 'clsx';
import { ErrorMessage } from 'formik';

export const ProgramEditVendor = ({
  setValue,
  initialValue,
  disabled,
  readOnly,
  isInvalid,
}: {
  setValue: (s: string) => void;
  initialValue: string;
  disabled: boolean;
  readOnly: boolean;
  isInvalid: boolean;
}) => {
  const [currentValue, setCurrentValue] = useState(initialValue ?? '');
  const onChange = useAsyncDebounce((v) => {
    setValue(v ?? undefined);
  }, DebounceMsConfig.programEditInputDebounceMs);

  useEffect(() => {
    setCurrentValue(initialValue || '');
  }, [initialValue]);

  function handleChange(v: string | null) {
    setCurrentValue(v ?? '');
    onChange(v);
  }

  return (
    <Form.Group controlId="Vendor" className="growegy-form__row">
      <label className="growegy-form__label">Vendor</label>
      <div>
        <input
          name="vendor"
          placeholder={disabled || readOnly ? '' : 'Add vendor'}
          value={currentValue}
          disabled={disabled}
          readOnly={readOnly}
          onChange={(
            e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
          ) => handleChange(e.target.value)}
          data-test="program-edit__vendor"
          className={clsx('growegy-form__input', 'program-edit__input-redesigned--sized', {
            'is-invalid': isInvalid,
          })}
        />
        <ErrorMessage
          component="div"
          name="vendor"
          className="invalid-feedback"
          data-test="program-edit__vendor-validation-error"
        />
      </div>
    </Form.Group>
  );
};
